import React, {useRef, useEffect, useMemo} from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { Formik, Form, Field } from 'formik';
import { InputFloatingLabel } from "../../formik";

const AddCreditsPopup = ({ intl, setShowAddCreds }) => {

  const node = useRef();

  const handleClick = useMemo((e) => {
    if (node.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click 
    setShowAddCreds(false)
  }, [setShowAddCreds]);

  useEffect(() => {
    // add when mounted
    document.addEventListener("mousedown", handleClick);
    // return function to be called when unmounted
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, [handleClick]);

  return (
    <div className="add-credits-popup-container">
      <div className="add-credits-popup" ref={node}>
        <div className="p-header">
          <h5>
            {intl.formatMessage({ id: 'add.credits' })}
            <Button onClick={() => setShowAddCreds(false)}><img src="/icons/close.png" alt="close" /></Button>
          </h5>
        </div>
        <div className="form-p p-add-c-form">
          <Formik
            initialValues={{
              numberofcredits: '',
            }}
            onSubmit={values => console.log(values)}
          >
            {({ values, handleSubmit }) => {
              return (
                <Form>
                  <Row className="align-items-center">
                    <Col xs={8}>
                      <Field
                        component={InputFloatingLabel}
                        type="number"
                        placeholder={intl.formatMessage({
                          id: "no.credits",
                        })}
                        label={intl.formatMessage({
                          id: "no.credits",
                        })}
                        name="numberofcredits"
                        id="numberofcredits"
                        required
                      />
                    </Col>
                    <Col xs={4}>
                      <p>{intl.formatMessage({ id: 'is' })} <b>{values.numberofcredits * 400}€</b></p>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Button onClick={handleSubmit} className="p-button">{intl.formatMessage({ id: 'proceed.payment' })}</Button>
                    </Col>
                  </Row>
                </Form>
              )
            }}
          </Formik>
        </div>
      </div>
    </div>
  )
}

export default AddCreditsPopup;